export const it = {
  // Sidebar
  ppp_procedimenti: 'Procedimenti PPP',
  op_organizzazione: 'Profilo aziendale',

  // Pagine / titoli
  ppp_lista_titolo: 'Procedimenti PPP',
  ppp_nuovo_procedimento: 'Nuovo procedimento',
  ppp_nessun_risultato: 'Nessun procedimento trovato.',
  ppp_cerca_placeholder: 'Cerca procedimento...',

  // Dettaglio
  ppp_torna_lista: 'Procedimenti',
  ppp_fase_attiva: 'Fase attiva',
  ppp_non_avviato: 'Non avviato',
  ppp_rup: 'RUP',
  ppp_anno_programmazione: 'Anno programmazione',
  ppp_importo_stimato: 'Importo stimato',
  ppp_ente_concedente: 'Ente Concedente',
  ppp_non_trovato: 'Procedimento non trovato.',

  // Tab
  ppp_tab_fasi: 'Fasi',
  ppp_tab_scadenze: 'Scadenze',
  ppp_tab_proposte: 'Proposte',
  ppp_tab_documenti: 'Documenti',
  ppp_tab_atti: 'Atti',
  ppp_tab_schema_valutazione: 'Schema Valutazione (F8)',
  ppp_tab_verbale_valutazione: 'Valutazione Comparativa (F9)',

  // Colonne tabella
  ppp_col_codice: 'Codice',
  ppp_col_titolo: 'Titolo',
  ppp_col_ente: 'Ente Concedente',
  ppp_col_fase: 'Fase',
  ppp_col_stato: 'Stato',
  ppp_col_rup: 'RUP',
  ppp_apri: 'Apri',
  ppp_elimina: 'Elimina',
  ppp_elimina_titolo: 'Elimina procedimento',
  ppp_elimina_messaggio: 'Sei sicuro di voler eliminare questo procedimento? L\'operazione non è reversibile.',

  // Stati procedimento
  ppp_stato_bozza: 'Bozza',
  ppp_stato_avviato: 'Avviato',
  ppp_stato_sospeso: 'Sospeso',
  ppp_stato_concluso: 'Concluso',
  ppp_stato_archiviato: 'Archiviato',

  // Stati fase
  ppp_fase_non_avviata: 'Non avviata',
  ppp_fase_in_corso: 'In corso',
  ppp_fase_completata: 'Completata',
  ppp_fase_conclusa: 'Conclusa',
  ppp_fase_sospesa: 'Sospesa',
  ppp_fase_in_ritardo: 'In ritardo',

  // Form nuovo procedimento
  ppp_form_titolo: 'Titolo',
  ppp_form_ente_concedente: 'Ente Concedente',
  ppp_form_descrizione: 'Descrizione',
  ppp_form_anno: 'Anno di programmazione',
  ppp_form_importo: 'Importo stimato (€)',
  ppp_form_settore: 'Settore',
  ppp_form_note: 'Note',
  ppp_form_rup: 'RUP',
  ppp_form_rup_dopo: 'Il RUP potrà essere invitato e assegnato dopo la creazione, dal dettaglio del procedimento.',
  ppp_form_crea: 'Crea procedimento',
  ppp_form_annulla: 'Annulla',
  ppp_nuovo_titolo: 'Nuovo Procedimento PPP',

  // Scadenze
  ppp_scadenze_vuote: 'Nessuna scadenza presente.',
  ppp_scadenza_scade_il: 'Scade il',
  ppp_scadenza_prorogata_al: 'Prorogata al',
  ppp_scadenza_scaduta: 'SCADUTA',
  ppp_scadenza_rispettata: 'RISPETTATA',
  ppp_scadenza_giorni: 'gg',
  ppp_scadenza_chiudi: 'Segna rispettata',
  ppp_scadenza_torna_lista: 'Tutte le scadenze',
  ppp_scadenze_rispettate: 'Scadenze rispettate',

  // Proroga scadenza
  ppp_proroga_titolo: 'Proroga scadenza',
  ppp_proroga_nuova_data: 'Nuova data di scadenza',
  ppp_proroga_motivazione: 'Motivazione (obbligatoria)',
  ppp_proroga_motivazione_placeholder: 'Indicare le ragioni della proroga secondo normativa...',
  ppp_proroga_conferma: 'Conferma proroga',
  ppp_proroga_azione: 'Proroga',
  ppp_proroga_motivo: 'Motivazione proroga',
  ppp_proroga_storico: 'Storico proroghe',
  ppp_proroga_errore_validazione: 'Inserire una data futura e una motivazione di almeno 10 caratteri.',
  ppp_proroga_allegato_label: 'Allegato (opzionale — es. determina o atto dell\'ente)',
  ppp_proroga_allegato_hint: 'Formati accettati: PDF, DOC, DOCX, ODT, PNG, JPG — max 50 MB',

  // Report ritardi
  ppp_report_ritardi_titolo: 'Report ritardi procedurali',
  ppp_report_ritardi_sottotitolo: 'Scadenze superate nei procedimenti assegnati (art. 2 co. 9 L. 241/1990)',
  ppp_report_nessun_ritardo: 'Nessun ritardo rilevato.',
  ppp_report_col_procedimento: 'Procedimento',
  ppp_report_col_scadenza: 'Scadenza',
  ppp_report_col_data: 'Data scadenza',
  ppp_report_col_ritardo: 'Giorni ritardo',
  ppp_report_col_normativa: 'Riferimento normativo',

  // Toast / feedback
  ppp_procedimento_creato: 'Procedimento creato correttamente',
  ppp_procedimento_aggiornato: 'Procedimento aggiornato correttamente',
  ppp_procedimento_eliminato: 'Procedimento eliminato correttamente',
  ppp_fase_avanza: 'Avanza fase',
  ppp_fase_avanza_titolo: 'Avanza fase',
  ppp_fase_avanza_messaggio: 'Stai per avanzare alla fase {fase}. Le fasi precedenti non ancora avviate verranno marcate come concluse. Confermi?',
  ppp_fase_retrocedi: 'Torna a questa fase',
  ppp_fase_retrocedi_titolo: 'Torna a questa fase',
  ppp_fase_retrocedi_messaggio: 'Stai per tornare alla fase {fase}. Tutte le fasi successive torneranno allo stato "non avviata". Confermi?',
  ppp_fase_avanzata: 'Fase avanzata correttamente',
  ppp_errore_generico: 'Si è verificato un errore. Riprova.',

  // Blocco procedimento fino a nomina RUP
  ppp_blocco_rup_titolo: 'Procedimento in attesa di nomina RUP',
  ppp_blocco_rup_descrizione: 'Per procedere: assegna un RUP tramite la select, genera il decreto di nomina dalla tab "Atti" e approvalo.',
  ppp_blocco_rup_mancante: 'Procedimento bloccato: assegna prima un RUP tramite la select in cima alla pagina.',
  ppp_blocco_atto_descrizione: 'RUP assegnato. Ora genera il decreto di nomina dalla tab "Atti" e approvalo per sbloccare il procedimento.',
  ppp_blocco_atto_mancante: 'Procedimento bloccato: genera il decreto di nomina RUP dalla tab "Atti" e approvalo per procedere.',

  // RUP
  ppp_rup_non_assegnato: '— Nessun RUP —',
  ppp_rup_invita: 'Invita RUP',
  ppp_rup_email: 'Email o PEC del RUP',
  ppp_rup_invito_inviato: "Invito inviato: il RUP riceverà un link per registrarsi.",
  ppp_rup_assegnato: 'RUP assegnato al procedimento.',
  ppp_modifica: 'modifica',
  ppp_annulla: 'Annulla',
  ppp_salva: 'Salva',
  ppp_caricamento: 'Caricamento...',

  // Atti
  ppp_atti_vuoti: 'Nessun atto presente.',
  ppp_atti_genera_titolo: 'Genera atti precompilati',
  ppp_atti_genera_nomina_rup: 'Nomina RUP (art. 15 D.lgs 36/2023)',
  ppp_atti_genera_avvio: 'Delibera/Determinazione di avvio',
  ppp_atti_genera_comunicazione: 'Comunicazione di avvio (L. 241/1990)',
  ppp_atti_genera_approvazione_dip: 'Approvazione DIP (art. 41)',
  ppp_atti_genera_selezione_proposte: 'Atto selezione proposte (art. 193 co. 9)',
  ppp_atti_genera_richiesta_integrazioni: 'Richiesta integrazioni documentali',
  ppp_atti_nomina_rup_warning: 'Assegna un RUP prima di generare la nomina.',
  ppp_atti_emesso_il: 'Emesso il',
  ppp_atti_pubblicato_il: 'Pubblicato il',
  ppp_atti_scarica_pdf: 'Scarica PDF',
  ppp_atti_invia_firma: 'Invia a firma',
  ppp_atti_approva: 'Approva',
  ppp_atti_pubblica: 'Pubblica',
  ppp_atti_genera: 'Genera',
  ppp_atti_tipo: 'Tipo atto',
  ppp_atti_dip_id: 'ID del DIP',
  ppp_atti_richiesta_id: 'ID Richiesta integrazioni',
  ppp_atti_avvio_titolo: 'Delibera/Determinazione di avvio procedimento',
  ppp_atti_comunicazione_avvio_titolo: 'Comunicazione di avvio (artt. 7-8 L. 241/1990)',
  ppp_atti_approvazione_dip_titolo: 'Delibera/Determinazione di approvazione DIP',
  ppp_atti_selezione_proposte_titolo: 'Atto di selezione proposta — Valutazione comparativa finale',
  ppp_atti_richiesta_integrazioni_titolo: 'Richiesta formale integrazioni documentali (art. 193 co. 8)',
  ppp_atti_ufficio_responsabile: 'Ufficio responsabile',
  ppp_atti_termine_giorni: 'Termine conclusione (giorni)',
  ppp_atti_modalita_accesso: 'Modalità accesso agli atti',
  ppp_atti_sostitutiva_nome: 'Titolare potere sostitutivo (art. 2 co. 9-bis)',
  ppp_atti_sostitutiva_contatto: 'Riferimento sostitutivo',

  // Vista procedimenti assegnati
  ppp_assegnati_titolo: 'Procedimenti assegnati',
  ppp_assegnati_sottotitolo: 'Procedimenti PPP di cui sei RUP.',
  ppp_assegnati_sidebar: 'I miei procedimenti',

  // Alert configurazione
  ppp_alert_titolo: 'Configura alert scadenza',
  ppp_alert_azione: 'Alert',
  ppp_alert_giorni_label: 'Giorni di anticipo per l\'alert',
  ppp_alert_giorni_hint: 'Valore tra 1 e 90 giorni.',

  // Report ritardi sidebar
  ppp_report_ritardi_sidebar: 'Report ritardi',

  // Documenti
  ppp_doc_carica: 'Carica documento',
  ppp_doc_vuoti: 'Nessun documento presente.',
  ppp_doc_scarica: 'Scarica',
  ppp_doc_scarica_zip: 'Scarica ZIP',
  ppp_doc_elimina: 'Elimina',
  ppp_doc_nuova_versione: 'Nuova versione',
  ppp_doc_tipo: 'Tipo documento',
  ppp_doc_ufficio: 'Ufficio',
  ppp_doc_rif_normativo: 'Riferimento normativo',
  ppp_doc_note: 'Note',
  ppp_doc_versione: 'v',
  ppp_doc_stato_bozza: 'Bozza',
  ppp_doc_stato_in_revisione: 'In revisione',
  ppp_doc_stato_approvato: 'Approvato',
  ppp_doc_stato_pubblicato: 'Pubblicato',
  ppp_doc_cambia_stato: 'Cambia stato',
  ppp_doc_checklist_titolo: 'Checklist documenti',
  ppp_doc_checklist_richiesti: 'Documenti richiesti per fase',
  ppp_doc_checklist_completo: 'Completo',
  ppp_doc_checklist_mancante: 'Mancante',
  ppp_doc_checklist_vuota: 'Nessun requisito documentale configurato per questa fase.',
  ppp_doc_upload_titolo: 'Carica nuovo documento',
  ppp_doc_fase_label: 'Fase (opzionale)',
  ppp_doc_caricato: 'Documento caricato correttamente',
  ppp_doc_eliminato: 'Documento eliminato',
  ppp_doc_stato_aggiornato: 'Stato aggiornato',
  ppp_doc_nuova_ver_caricata: 'Nuova versione caricata',
  ppp_doc_obbligatorio: 'Obbligatorio',
  ppp_doc_facoltativo: 'Facoltativo',
  ppp_doc_mostra_checklist: 'Verifica requisiti',
  ppp_doc_nascondi_checklist: 'Nascondi requisiti',
  ppp_doc_seleziona_tipo: '— Seleziona tipo —',
  ppp_doc_seleziona_fase: '— Nessuna fase —',

  // Programmazione Triennale PPP (art. 175 D.lgs 36/2023)
  ppp_programmazione_sidebar: 'Programmazione Triennale',
  ppp_programmazione_lista_titolo: 'Programmazione Triennale PPP',
  ppp_programmazione_lista_sottotitolo: 'Gestione del programma triennale dei lavori pubblici (art. 175 D.lgs 36/2023)',
  ppp_programmazione_nuovo: 'Nuovo programma',
  ppp_programmazione_nessun_risultato: 'Nessun programma triennale trovato.',
  ppp_programmazione_triennio: 'Triennio',
  ppp_programmazione_col_ente: 'Ente Concedente',
  ppp_programmazione_col_triennio: 'Triennio',
  ppp_programmazione_col_stato: 'Stato',
  ppp_programmazione_col_interventi: 'Interventi',
  ppp_programmazione_col_importo: 'Importo totale',
  ppp_programmazione_col_delibera: 'Delibera',

  // Stati programma triennale
  ppp_prog_stato_bozza: 'Bozza',
  ppp_prog_stato_approvato: 'Approvato',
  ppp_prog_stato_pubblicato: 'Pubblicato',
  ppp_prog_stato_archiviato: 'Archiviato',

  // Form nuovo programma
  ppp_prog_form_ente: 'Ente Concedente',
  ppp_prog_form_anno: 'Anno di inizio triennio',
  ppp_prog_form_note: 'Note',
  ppp_prog_form_crea: 'Crea programma',
  ppp_prog_form_annulla: 'Annulla',
  ppp_prog_nuovo_titolo: 'Nuovo Programma Triennale PPP',
  ppp_prog_form_descrizione: 'Indica l\'ente e l\'anno di avvio del triennio (es. 2026 → triennio 2026-2028).',

  // Dettaglio programma
  ppp_prog_torna_lista: 'Programmazione',
  ppp_prog_ente: 'Ente Concedente',
  ppp_prog_anno: 'Anno di riferimento',
  ppp_prog_note: 'Note',
  ppp_prog_delibera: 'Delibera approvazione',
  ppp_prog_data_approvazione: 'Data approvazione',
  ppp_prog_approvato_da: 'Approvato da',
  ppp_prog_url_bdncp: 'Pubblicazione BDNCP',
  ppp_prog_non_pubblicato: 'Non ancora pubblicato',
  ppp_prog_apri_bdncp: 'Apri pubblicazione',
  ppp_prog_scarica_delibera: 'Scarica delibera PDF',
  ppp_prog_modifica: 'Modifica',
  ppp_prog_salva: 'Salva',
  ppp_prog_annulla: 'Annulla',

  // Azioni stato programma
  ppp_prog_approva: 'Approva delibera',
  ppp_prog_pubblica: 'Pubblica su BDNCP',
  ppp_prog_approva_titolo: 'Approvazione Programma Triennale',
  ppp_prog_pubblica_titolo: 'Pubblicazione su BDNCP',
  ppp_prog_numero_delibera: 'Numero delibera',
  ppp_prog_data_delibera: 'Data delibera',
  ppp_prog_url_bdncp_label: 'URL pubblicazione BDNCP (opzionale)',
  ppp_prog_conferma_approva: 'Approva',
  ppp_prog_conferma_pubblica: 'Pubblica',

  // Interventi
  ppp_prog_interventi_titolo: 'Interventi',
  ppp_prog_interventi_vuoti: 'Nessun intervento aggiunto.',
  ppp_prog_intervento_nuovo: 'Aggiungi intervento',
  ppp_prog_intervento_modifica: 'Modifica intervento',
  ppp_prog_intervento_elimina: 'Elimina intervento',
  ppp_prog_intervento_elimina_msg: 'Sei sicuro di voler eliminare questo intervento?',
  ppp_prog_int_titolo: 'Titolo intervento',
  ppp_prog_int_annualita: 'Annualità',
  ppp_prog_int_annualita_1: '1° anno (Elenco Annuale)',
  ppp_prog_int_annualita_2: '2° anno',
  ppp_prog_int_annualita_3: '3° anno',
  ppp_prog_int_importo: 'Importo (€)',
  ppp_prog_int_importo_hint: 'Importo minimo €150.000 (art. 50 c.1 lett.a)',
  ppp_prog_int_fonte: 'Fonte di finanziamento',
  ppp_prog_int_settore: 'Settore',
  ppp_prog_int_codice: 'Codice intervento (opzionale)',
  ppp_prog_int_descrizione: 'Descrizione',
  ppp_prog_int_note_fin: 'Note finanziamento',
  ppp_prog_int_procedimento: 'Collegamento procedimento PPP',
  ppp_prog_int_procedimento_placeholder: '— Nessun procedimento collegato —',
  ppp_prog_int_salva: 'Salva intervento',

  // Fonti di finanziamento
  ppp_fonte_bilancio_comunale: 'Bilancio comunale',
  ppp_fonte_mutuo: 'Mutuo',
  ppp_fonte_fondi_europei: 'Fondi europei',
  ppp_fonte_fondi_regionali: 'Fondi regionali',
  ppp_fonte_contributo_privato: 'Contributo privato',
  ppp_fonte_altro: 'Altro',

  // Toast feedback programmazione
  ppp_prog_creato: 'Programma triennale creato',
  ppp_prog_aggiornato: 'Programma aggiornato',
  ppp_prog_approvato: 'Programma approvato con successo',
  ppp_prog_pubblicato: 'Programma pubblicato su BDNCP',
  ppp_prog_intervento_aggiunto: 'Intervento aggiunto',
  ppp_prog_intervento_aggiornato: 'Intervento aggiornato',
  ppp_prog_intervento_eliminato: 'Intervento eliminato',
  ppp_prog_soglia_warning: 'Attenzione: importo inferiore alla soglia minima di €150.000',

  // Avviso Pubblico PPP (art. 193 co. 16 D.lgs 36/2023)
  ppp_avviso_sidebar: 'Avviso Pubblico (Fase 3)',
  ppp_avviso_titolo_lista: 'Avvisi Pubblici PPP',
  ppp_avviso_titolo_sottotitolo: 'Avvisi pubblici per la ricezione di proposte di partenariato (art. 193 co. 16 D.lgs 36/2023)',
  ppp_avviso_nuovo: 'Nuovo avviso',
  ppp_avviso_nuovo_titolo: 'Nuovo Avviso Pubblico PPP',
  ppp_avviso_nessuno: 'Nessun avviso pubblico trovato.',
  ppp_avviso_oggetto: 'Oggetto / Titolo avviso',
  ppp_avviso_oggetto_hint: 'Es. Avviso esplorativo per proposta PPP — Parcheggio interrato P.za Roma',
  ppp_avviso_stato: 'Stato',
  ppp_avviso_procedimento: 'Procedimento collegato',
  ppp_avviso_procedimento_placeholder: '— Nessun procedimento collegato —',
  ppp_avviso_descrizione_intervento: "Descrizione dell'intervento",
  ppp_avviso_descrizione_hint: "Descrizione dell'intervento incluso nella programmazione PPP (art. 193 co. 16 lett. a)",
  ppp_avviso_requisiti_minimi: 'Requisiti minimi delle proposte',
  ppp_avviso_requisiti_hint: 'Requisiti minimi che devono soddisfare le proposte (art. 193 co. 3 D.lgs 36/2023)',
  ppp_avviso_sopra_soglia_europea: 'Intervento sopra soglia europea (richiede pubblicazione GUUE)',
  ppp_avviso_sopra_soglia_label: 'Sopra soglia europea',
  ppp_avviso_numero_atto: 'Numero atto di approvazione',
  ppp_avviso_note: 'Note',
  ppp_avviso_salva: 'Salva',
  ppp_avviso_pubblica: 'Pubblica avviso',
  ppp_avviso_pubblica_hint: 'Indica la data di pubblicazione e il termine per la presentazione delle proposte (minimo 60 giorni dalla pubblicazione, art. 193 co. 16).',
  ppp_avviso_data_pubblicazione: 'Data di pubblicazione',
  ppp_avviso_termine_proposte: 'Termine presentazione proposte',
  ppp_avviso_termine_proposte_label: 'Termine presentazione proposte',
  ppp_avviso_termine_60gg_avviso: '⚠ Il termine deve essere almeno 60 giorni dopo la data di pubblicazione (art. 193 co. 16 D.lgs 36/2023)',
  ppp_avviso_url_amm_trasparente: 'Amm. Trasparente',
  ppp_avviso_url_bdncp: 'BDNCP',
  ppp_avviso_url_guue: 'GUUE (sopra soglia UE)',
  ppp_avviso_sezione_generale: 'Informazioni generali',
  ppp_avviso_sezione_contenuto: 'Contenuto obbligatorio',
  ppp_avviso_sezione_pubblicazione: 'Pubblicazione',
  // Stati avviso
  ppp_avviso_stato_bozza: 'Bozza',
  ppp_avviso_stato_pubblicato: 'Pubblicato',
  ppp_avviso_stato_scaduto: 'Scaduto',
  ppp_avviso_stato_revocato: 'Revocato',
  // Toast
  ppp_avviso_creato: 'Avviso pubblico creato',
  ppp_avviso_aggiornato: 'Avviso pubblico aggiornato',
  ppp_avviso_pubblicato_ok: 'Avviso pubblicato correttamente. Scadenza procedurale aggiornata.',
  ppp_avviso_eliminato: 'Avviso eliminato',
  // Registro operatori
  ppp_avviso_sezione_operatori: 'Registro operatori interessati',
  ppp_avviso_operatori_hint: 'Operatori economici che hanno richiesto informazioni sull\'avviso (art. 193 co. 16 D.lgs 36/2023).',
  ppp_avviso_operatori_nessuno: 'Nessun operatore registrato.',
  ppp_avviso_aggiungi_operatore: 'Registra operatore',
  ppp_avviso_operatore_ragione_sociale: 'Ragione sociale',
  ppp_avviso_operatore_email: 'Email',
  ppp_avviso_operatore_pec: 'PEC',
  ppp_avviso_operatore_telefono: 'Telefono',
  ppp_avviso_operatore_data_registrazione: 'Data registrazione',
  ppp_avviso_operatore_note: 'Note',
  ppp_avviso_operatore_registrato: 'Operatore registrato',
  // Richieste di integrazione
  ppp_avviso_sezione_richieste: 'Richieste di integrazione documentale',
  ppp_avviso_richieste_hint: 'Richieste di chiarimenti o integrazioni ricevute dagli operatori. La risposta viene pubblicata a tutti gli interessati (parità informativa art. 193 co. 16).',
  ppp_avviso_richieste_nessuna: 'Nessuna richiesta di integrazione.',
  ppp_avviso_aggiungi_richiesta: 'Nuova richiesta',
  ppp_avviso_richiesta_operatore: 'Operatore',
  ppp_avviso_richiesta_oggetto: 'Oggetto',
  ppp_avviso_richiesta_testo: 'Testo della richiesta',
  ppp_avviso_richiesta_data: 'Data richiesta',
  ppp_avviso_richiesta_stato: 'Stato',
  ppp_avviso_richiesta_stato_ricevuta: 'Ricevuta',
  ppp_avviso_richiesta_stato_risposta_pubblicata: 'Risposta pubblicata',
  ppp_avviso_richiesta_testo_risposta: 'Testo della risposta',
  ppp_avviso_richiesta_data_risposta: 'Data risposta',
  ppp_avviso_richiesta_pubblica_risposta: 'Pubblica risposta',
  ppp_avviso_richiesta_rispondi: 'Rispondi',
  ppp_avviso_risposta_allegato: 'Documento allegato (opzionale)',
  ppp_avviso_risposte_integrazioni: 'Risposte della PA',
  ppp_avviso_richiesta_pubblica_hint: 'La risposta sarà pubblicata e notificata a tutti gli operatori registrati per questo avviso.',
  ppp_avviso_richiesta_invii: 'Inviata a',
  ppp_avviso_richiesta_creata: 'Richiesta di integrazione registrata',
  ppp_avviso_risposta_pubblicata: 'Risposta pubblicata e inviata a tutti gli operatori',
  // Allegati avviso
  ppp_avviso_allegati: 'Allegati',
  ppp_avviso_allegati_nessuno: 'Nessun allegato caricato.',
  ppp_avviso_allegato_carica: 'Carica allegato',
  ppp_avviso_allegato_elimina: 'Elimina allegato',
  ppp_avviso_allegato_caricato: 'Allegato caricato',
  ppp_avviso_allegato_eliminato: 'Allegato eliminato',
  ppp_avviso_allegato_nome_placeholder: 'Nome allegato (opzionale)',
  // Revoca e versioning
  ppp_avviso_revoca: 'Revoca avviso',
  ppp_avviso_revoca_hint: 'La revoca è definitiva. Inserire la data, la motivazione e allegare l\'atto formale di revoca. Sarà possibile creare una nuova versione dell\'avviso dopo la revoca.',
  ppp_avviso_revoca_conferma: 'Conferma revoca',
  ppp_avviso_revocato_ok: 'Avviso revocato correttamente.',
  ppp_avviso_data_revoca: 'Data revoca',
  ppp_avviso_motivo_revoca: 'Motivazione della revoca',
  ppp_avviso_atto_revoca: 'Atto di revoca (file)',
  ppp_avviso_crea_versione: 'Crea nuova versione',
  ppp_avviso_nuova_versione_ok: 'Nuova versione dell\'avviso creata come bozza.',
  ppp_avviso_versione_precedente: 'Versione precedente',
  // Notifica email alla pubblicazione
  ppp_avviso_invia_notifica_email: 'Invia notifica email a tutti gli operatori registrati nel sistema',
  // Portale operatore — avvisi
  ppp_avviso_operatore_lista_hint: 'Avvisi pubblicati dalla Pubblica Amministrazione (art. 193 D.lgs 36/2023)',
  ppp_avviso_operatore_interesse: 'Registra interesse',
  ppp_avviso_operatore_gia_registrato: 'Interesse registrato',
  ppp_avviso_operatore_interesse_ok: 'Interesse registrato con successo.',
  ppp_avviso_richiedi_documenti: 'Richiesta documenti integrativi',
  ppp_avviso_richiedi_documenti_hint: 'Puoi richiedere chiarimenti o documentazione integrativa alla Pubblica Amministrazione.',
  // Generici
  ppp_si: 'Sì',
  ppp_no: 'No',

  // Portale Ricezione Proposte PPP (F04 — art. 193 D.lgs 36/2023)
  ppp_proposte_sidebar: 'Proposte (Fase 4)',
  ppp_proposte_titolo_lista: 'Registro Proposte PPP',
  ppp_proposte_sottotitolo: 'Ricezione, protocollazione e verifica formale delle proposte di partenariato (art. 193, co. 3 e 16, D.lgs 36/2023)',
  ppp_proposte_nessuna: 'Nessuna proposta ricevuta.',
  ppp_proposte_filtri: 'Filtra proposte',
  ppp_proposte_tutti_procedimenti: '— Tutti i procedimenti —',
  ppp_proposte_torna_lista: 'Proposte',
  // Form creazione proposta
  ppp_proposta_registra: 'Registra proposta',
  ppp_proposta_nuova_titolo: 'Registra nuova Proposta PPP',
  ppp_proposta_registra_btn: 'Protocolla e registra',
  ppp_proposta_titolo: 'Titolo / Oggetto della proposta',
  ppp_proposta_titolo_hint: 'Es. Proposta PPP Parcheggio interrato P.za Roma',
  ppp_proposta_tipo: 'Tipo proposta',
  ppp_proposta_tipo_spontanea: 'Spontanea',
  ppp_proposta_tipo_risposta_avviso: 'Risposta ad avviso',
  ppp_proposta_tipo_spontanea_normativa: 'Proposta presentata autonomamente dal promotore ai sensi dell\'art. 193, co. 3, D.lgs 36/2023.',
  ppp_proposta_tipo_risposta_normativa: 'Proposta presentata in risposta all\'avviso pubblico ai sensi dell\'art. 193, co. 16, D.lgs 36/2023.',
  ppp_proposta_avviso_riferimento: 'Avviso pubblico di riferimento',
  ppp_proposta_avviso_placeholder: '— Seleziona avviso —',
  ppp_proposta_operatore: 'Operatore economico (promotore)',
  ppp_proposta_operatore_placeholder: '— Seleziona operatore —',
  ppp_proposta_procedimento: 'Procedimento PPP',
  ppp_proposta_procedimento_placeholder: '— Seleziona procedimento —',
  ppp_proposta_data_ricezione: 'Data di ricezione',
  ppp_proposta_data_presentazione: 'Data di presentazione',
  ppp_proposta_importo_spese: 'Importo spese sostenute (€)',
  ppp_proposta_descrizione: 'Descrizione proposta',
  ppp_proposta_descrizione_hint: 'Descrizione sintetica dell\'intervento proposto',
  ppp_proposta_note: 'Note',
  ppp_proposta_protocollo: 'N° Protocollo',
  ppp_proposta_prot: 'Protocollo',
  // Colonne tabella
  ppp_proposta_stato: 'Stato',
  // Stati
  ppp_proposta_stato_ricevuta: 'Ricevuta',
  ppp_proposta_stato_in_valutazione: 'In valutazione',
  ppp_proposta_stato_ammessa: 'Ammessa',
  ppp_proposta_stato_respinta: 'Respinta',
  ppp_proposta_stato_ritirata: 'Ritirata',
  // Sezioni dettaglio
  ppp_proposta_sezione_protocollazione: 'Protocollazione',
  ppp_proposta_sezione_tipo: 'Tipo e riferimento normativo',
  ppp_proposta_sezione_operatore: 'Operatore economico',
  ppp_proposta_sezione_dati: 'Dati proposta',
  ppp_proposta_sezione_valutazione: 'Esito valutazione',
  // Tab
  ppp_proposta_tab_generale: 'Generale',
  ppp_proposta_tab_documenti: 'Documenti',
  ppp_proposta_tab_valutazione: 'Valutazione',
  // Valutazione
  ppp_proposta_valuta_btn: 'Registra valutazione',
  ppp_proposta_valuta_titolo: 'Valutazione proposta',
  ppp_proposta_valuta_conferma: 'Salva valutazione',
  ppp_proposta_esito_valutazione: 'Esito valutazione',
  ppp_proposta_note_valutazione: 'Note valutazione',
  ppp_proposta_note_valutazione_hint: 'Motivazione dell\'esito e riferimenti istruttori...',
  // Toast
  ppp_proposta_registrata: 'Proposta registrata e protocollata correttamente',
  ppp_proposta_valutata: 'Valutazione registrata',
  ppp_proposta_scarica_ricevuta: 'Scarica ricevuta PDF',

  // DIP — Documento di Indirizzo alla Progettazione (art. 3 Allegato I.7 D.lgs 36/2023)
  ppp_dip_sidebar: 'DIP (Fase 2)',
  ppp_dip_titolo_lista: 'Documenti di Indirizzo alla Progettazione (DIP)',
  ppp_dip_nuovo: 'Nuovo DIP',
  ppp_dip_nessuno: 'Nessun DIP trovato.',
  ppp_dip_oggetto: 'Oggetto / Titolo',
  ppp_dip_stato: 'Stato',
  ppp_dip_procedimento: 'Procedimento collegato',
  ppp_dip_procedimento_placeholder: '— Nessun procedimento collegato —',
  ppp_dip_limite_economico: 'Limite economico (€)',
  ppp_dip_data_decisione_avvio: 'Data decisione di avvio',
  ppp_dip_data_termine_redazione: 'Scadenza redazione (30-60 gg)',
  ppp_dip_data_approvazione: 'Data approvazione',
  ppp_dip_approva: 'Approva DIP',
  ppp_dip_invia_revisione: 'Invia in revisione',
  ppp_dip_elimina: 'Elimina DIP',
  ppp_dip_elimina_msg: 'Sei sicuro di voler eliminare questo DIP?',
  ppp_dip_stato_dei_luoghi: 'Stato dei luoghi',
  ppp_dip_stato_dei_luoghi_hint: 'Dati catastali, rilievi, modelli GIS',
  ppp_dip_obiettivi_fabbisogni: "Obiettivi e fabbisogni dell'intervento",
  ppp_dip_livelli_servizio: 'Livelli di servizio e requisiti prestazionali',
  ppp_dip_requisiti_tecnici: 'Requisiti tecnici normativi',
  ppp_dip_copertura_finanziaria: 'Coperture finanziarie',
  ppp_dip_ha_docfap: 'Intervento sopra soglia UE (richiede DOCFAP)',
  ppp_dip_numero_docfap: 'Numero/riferimento DOCFAP',
  ppp_dip_note: 'Note',
  ppp_dip_salva: 'Salva',
  ppp_dip_stato_bozza: 'Bozza',
  ppp_dip_stato_in_revisione: 'In revisione',
  ppp_dip_stato_approvato: 'Approvato',
  ppp_dip_numero_atto: 'Numero atto di approvazione',
  ppp_dip_numero_atto_hint: 'Es. Det. Dir. n. 42/2026',
  ppp_dip_approvato_da: 'Approvato da',
  ppp_dip_creato: 'DIP creato',
  ppp_dip_aggiornato: 'DIP aggiornato',
  ppp_dip_inviato_revisione: 'DIP inviato in revisione',
  ppp_dip_approvato_ok: 'DIP approvato con successo',
  ppp_dip_eliminato: 'DIP eliminato',
  ppp_dip_scarica_delibera: 'Scarica delibera PDF',
  ppp_dip_scadenza_redazione: 'Scadenza redazione DIP',
  ppp_dip_proposte_collegate: 'Proposte PPP collegate — Verifica coerenza (Fase 4-6)',
  ppp_dip_proposte_collegate_hint: 'Le proposte ricevute per questo procedimento. Verificare la coerenza con i contenuti del DIP (art. 3 Allegato I.7).',
  ppp_dip_proposta_senza_titolo: 'Proposta senza titolo',
  ppp_dip_proposta_operatore: 'Operatore economico',
  ppp_dip_proposta_presentata: 'Presentata il',
  ppp_proposta_stato_ricevuta: 'Ricevuta',
  ppp_proposta_stato_in_valutazione: 'In valutazione',
  ppp_proposta_stato_ammessa: 'Ammessa',
  ppp_proposta_stato_respinta: 'Respinta',
  ppp_proposta_stato_ritirata: 'Ritirata',

  // Widget dashboard overview — stat card
  ppp_widget_procedimenti_attivi: 'Procedimenti attivi',
  ppp_widget_procedimenti_totali_sub: '{n} totali nel sistema',
  ppp_widget_scadenze_imminenti: 'Scadenze prossimi 7 giorni',
  ppp_widget_scadenze_oggi_sub: '{n} scadono oggi',
  ppp_widget_scadenze_sette_giorni: 'Nei prossimi 7 giorni',
  ppp_widget_scadenze_in_ritardo: 'Scadenze in ritardo',
  ppp_widget_ritardi_art2: 'Art. 2 co. 9 L. 241/1990',
  ppp_widget_nessun_ritardo: 'Nessun ritardo rilevato',

  // Widget kanban fasi
  ppp_widget_kanban_titolo: 'Stato avanzamento procedure PPP',
  ppp_widget_kanban_cerca: 'Cerca procedimento, RUP...',
  ppp_widget_kanban_fasi: 'Avanzamento fasi',
  ppp_widget_kanban_vuoto: 'Nessun procedimento attivo.',

  // Widget scadenze imminenti lista
  ppp_widget_scadenze_lista_titolo: 'Scadenze in arrivo',
  ppp_widget_scadenze_lista_vuota: 'Nessuna scadenza nel periodo selezionato.',
  ppp_widget_oggi: 'OGGI',

  // Widget KPI fasi
  ppp_widget_kpi_titolo: 'Tempi medi per fase',
  ppp_widget_kpi_sottotitolo: 'Confronto tra tempo medio effettivo e termine di legge per ogni fase conclusa',
  ppp_widget_kpi_vuoto: 'Nessuna fase conclusa — dati non ancora disponibili.',
  ppp_widget_kpi_media: 'Media',
  ppp_widget_kpi_legale: 'limite legale',
  ppp_widget_kpi_nessun_dato: 'Nessun dato',
  ppp_widget_kpi_termine_legale: 'Termine legale',
  ppp_widget_kpi_tempo_medio_ok: 'Tempo medio (nei termini)',
  ppp_widget_kpi_tempo_medio_ritardo: 'Tempo medio (in ritardo)',

  // Valutazione Interesse Pubblico (F05-F06)
  ppp_proposta_stato_interesse_pubblico_dichiarato: 'Interesse pubblico dichiarato',

  ppp_valutazione_criteri_titolo: 'Criteri di valutazione',
  ppp_criterio_coerenza_programmazione: 'Coerenza con programmazione PPP (art. 175, co. 1)',
  ppp_criterio_coerenza_dip: 'Coerenza con il DIP approvato',
  ppp_criterio_fattibilita_tecnica: 'Fattibilità tecnica',
  ppp_criterio_sostenibilita_economica: 'Sostenibilità economico-finanziaria',
  ppp_criterio_non_valutato: 'Non valutato',
  ppp_criterio_positivo: 'Positivo ✓',
  ppp_criterio_negativo: 'Negativo ✗',

  ppp_note_ufficio_tecnico: 'Note Ufficio Tecnico',
  ppp_note_ufficio_amministrativo: 'Note Ufficio Amministrativo',

  // NARS
  ppp_nars_titolo: 'Parere NARS',
  ppp_nars_richiesto: 'Richiesto',
  ppp_nars_richiesto_label: 'Richiedi parere NARS',
  ppp_nars_stato: 'Stato parere',
  ppp_nars_data_richiesta: 'Data richiesta',
  ppp_nars_data_risposta: 'Data risposta',
  ppp_nars_note: 'Note NARS',
  ppp_nars_stato_non_richiesto: 'Non richiesto',
  ppp_nars_stato_richiesto: 'Richiesto',
  ppp_nars_stato_in_attesa: 'In attesa',
  ppp_nars_stato_ricevuto: 'Ricevuto',
  ppp_nars_stato_negativo: 'Negativo',

  ppp_valutazione_ip_btn: 'Scheda valutazione',
  ppp_valutazione_ip_titolo: 'Scheda valutazione interesse pubblico',
  ppp_valutazione_ip_salvata: 'Scheda di valutazione salvata',

  ppp_dichiara_interesse_pubblico_btn: 'Dichiara interesse pubblico',
  ppp_dichiara_interesse_pubblico_titolo: 'Dichiarazione di interesse pubblico — art. 193, co. 5',
  ppp_dichiara_ip_avviso: 'Verrà generata una determinazione dirigenziale di dichiarazione di interesse pubblico. La proposta passerà allo stato "Interesse pubblico dichiarato" e partirà automaticamente il timer di 60 giorni per le proposte concorrenti.',
  ppp_dichiara_interesse_pubblico_conferma: 'Genera determinazione',
  ppp_interesse_pubblico_dichiarato: 'Dichiarazione di interesse pubblico generata',

  ppp_atto_interesse_pubblico_generato: 'Determinazione di dichiarazione interesse pubblico generata',
  ppp_atto_numero: 'Numero determinazione',
  ppp_atto_note: 'Note',

  ppp_si: 'Sì',
  ppp_no: 'No',
  ppp_giorni: 'giorni',
  ppp_seleziona: 'Seleziona',

  // Fase 08 — Schema di Valutazione Comparativa (art. 193, co. 5 D.lgs 36/2023)
  ppp_schema_sidebar: 'Schema Valutazione (Fase 8)',
  ppp_schema_fase08_label: 'Schema di Valutazione Comparativa',
  ppp_schema_lista_titolo: 'Schemi di Valutazione Comparativa',
  ppp_schema_lista_descrizione: 'Schemi da predisporre durante il periodo di pubblicazione delle proposte concorrenti (art. 193, co. 5 D.lgs 36/2023).',
  ppp_schema_nuovo_btn: 'Nuovo schema',
  ppp_schema_nuovo_titolo: 'Nuovo Schema di Valutazione',
  ppp_schema_crea_btn: 'Crea schema',
  ppp_schema_nessuno: 'Nessuno schema di valutazione predisposto.',
  ppp_schema_nessuno_hint: 'Lo schema va preparato durante il periodo di raccolta delle proposte concorrenti.',
  ppp_schema_titolo: 'Titolo schema',
  ppp_schema_titolo_placeholder: 'Es. Schema di valutazione comparativa — Procedimento X',
  ppp_schema_descrizione: 'Descrizione',
  ppp_schema_descrizione_placeholder: 'Finalità e contesto dello schema di valutazione...',
  ppp_schema_note: 'Note',
  ppp_schema_sezione_generale: 'Informazioni generali',
  ppp_schema_proposta_promotore: 'Proposta Promotore di riferimento',
  ppp_schema_creato_il: 'Creato il',
  ppp_schema_approvato_il: 'Approvato il',
  ppp_schema_approvato_da: 'Approvato da',
  ppp_schema_non_trovato: 'Schema di valutazione non trovato.',

  // Stati schema
  ppp_schema_stato_bozza: 'Bozza',
  ppp_schema_stato_in_revisione: 'In revisione',
  ppp_schema_stato_approvato: 'Approvato',

  // Builder criteri
  ppp_schema_criteri_titolo: 'Criteri di valutazione',
  ppp_schema_criteri_n: 'criteri',
  ppp_schema_criteri_vuoti: 'Nessun criterio definito. Aggiungi criteri o applica un template predefinito.',
  ppp_schema_totale_peso: 'Totale pesi',
  ppp_schema_pesi_ok: '✓ La somma dei pesi è 100 — pronto per l\'approvazione',
  ppp_schema_pesi_troppo: '⚠ La somma dei pesi supera 100',
  ppp_schema_pesi_mancanti: 'Mancano {n}% per raggiungere 100',
  ppp_schema_avviso_pesi: '⚠ I pesi non sommano a 100. Per approvare lo schema, aggiusta i pesi dei criteri fino a raggiungere esattamente 100.',
  ppp_schema_aggiungi_criterio: 'Aggiungi criterio',
  ppp_schema_modifica_criterio: 'Modifica criterio',
  ppp_schema_criterio_nome: 'Nome criterio',
  ppp_schema_criterio_categoria: 'Categoria normativa',
  ppp_schema_criterio_peso: 'Peso (%)',
  ppp_schema_criterio_descrizione: 'Descrizione criterio',

  // Template predefiniti
  ppp_schema_template_placeholder: '— Applica template predefinito —',
  ppp_schema_template_base: 'Template base (40/30/30)',
  ppp_schema_template_infrastrutture: 'Infrastrutture (40/25/35)',
  ppp_schema_template_servizi: 'Servizi (30/40/30)',

  // Approvazione
  ppp_schema_approva_btn: 'Approva schema',
  ppp_schema_approva_titolo: 'Approvazione Schema di Valutazione',
  ppp_schema_approva_avviso: 'Una volta approvato, lo schema non potrà più essere modificato. Verifica che tutti i criteri siano corretti e che i pesi sommino a 100.',
  ppp_schema_approva_conferma: 'Approva definitivamente',
  ppp_schema_note_approvazione: 'Note di approvazione',
  ppp_schema_note_approvazione_hint: 'Note del RUP/Dirigente sull\'approvazione dello schema (opzionale)...',

  // Toast
  ppp_schema_creato: 'Schema di valutazione creato',
  ppp_schema_aggiornato: 'Schema di valutazione aggiornato',
  ppp_schema_approvato: 'Schema di valutazione approvato con successo',
  ppp_schema_scarica_pdf: 'Scarica PDF',

  // Fase 07 — Pubblicazione proposta di interesse pubblico
  ppp_proposta_tab_fase07: 'Fase 7 — Pubblicazione',
  ppp_fase07_titolo: 'Pubblicazione proposta di interesse pubblico',
  ppp_fase07_descrizione: 'La proposta dichiarata di interesse pubblico viene pubblicata nella sezione "Amministrazione Trasparente". Inizia il periodo di raccolta delle proposte concorrenti (minimo 60 giorni).',
  ppp_fase07_pubblicazione_titolo: 'Pubblicazione in Amministrazione Trasparente',
  ppp_fase07_data_pubblicazione: 'Data pubblicazione',
  ppp_fase07_termine_concorrenti: 'Termine proposte concorrenti',
  ppp_fase07_giorni_rimanenti: 'Giorni rimanenti',
  ppp_fase07_proponenti_titolo: 'Registro proponenti concorrenti',
  ppp_fase07_registra_concorrente_btn: 'Registra proposta concorrente',
  ppp_fase07_nessuna_proposta_concorrente: 'Nessuna proposta concorrente ricevuta.',
  ppp_fase07_non_ancora_pubblicata: 'La proposta è stata dichiarata di interesse pubblico ma non ancora pubblicata in Amministrazione Trasparente. Procedi con la pubblicazione per avviare il periodo di raccolta proposte concorrenti.',
  ppp_fase07_richiede_dichiarazione: 'La proposta deve prima essere dichiarata di interesse pubblico (Fase 6) per procedere con la pubblicazione.',
  ppp_fase07_pubblica_btn: 'Pubblica in Amministrazione Trasparente',
  ppp_fase07_pubblica_titolo: 'Pubblicazione proposta — Fase 7',
  ppp_fase07_pubblica_avviso: 'La proposta verrà pubblicata nella sezione "Amministrazione Trasparente". Partirà automaticamente la scadenza per la raccolta di proposte concorrenti e verrà inviata una notifica via PEC/email al Promotore originale.',
  ppp_fase07_giorni_termine_label: 'Giorni termine proposte concorrenti (min. 60)',
  ppp_fase07_pubblica_conferma: 'Pubblica e notifica Promotore',
  ppp_fase07_pubblicata: 'Proposta pubblicata in Amministrazione Trasparente. Il Promotore è stato notificato.',
  ppp_fase07_registra_concorrente_titolo: 'Registra proposta concorrente',
  ppp_fase07_concorrente_registrata: 'Proposta concorrente registrata con successo.',

  // Fase 10 — Richiesta Integrazioni Documentali e Conferenza di Servizi Preliminare
  ppp_proposta_tab_fase10: 'Fase 10 — Integrazioni',
  // Fase 11 — Valutazione Integrazioni Documentali
  ppp_proposta_tab_fase11: 'Fase 11 — Valutazione Integrazioni',
  // Fase 12 — Provvedimento di Ammissione o Respingimento
  ppp_proposta_tab_fase12: 'Fase 12 — Provvedimento',
  // Fase 13 — Integrazione e Approvazione PFTE
  ppp_proposta_tab_fase13: 'Fase 13 — PFTE',
  // Fase 14 — Predisposizione Documentazione di Gara
  ppp_proposta_tab_fase14: 'Fase 14 — Doc. Gara',

  ppp_tab_trasparenza: 'Trasparenza',

  // Trasparenza — Pubblicazioni obbligatorie
  ppp_trasparenza_titolo: 'Trasparenza e Pubblicazioni Obbligatorie',
  ppp_trasparenza_descrizione: 'Log centralizzato di tutte le pubblicazioni obbligatorie previste dalla normativa PPP (art. 28, art. 35 D.lgs 36/2023, D.lgs 33/2013).',
  ppp_trasparenza_tab_log: 'Log Pubblicazioni',
  ppp_trasparenza_elimina_titolo: 'Elimina pubblicazione',
  ppp_trasparenza_elimina_messaggio: 'Sei sicuro di voler eliminare questa registrazione? L\'operazione non può essere annullata.',
  ppp_trasparenza_log_hint: 'Registra ogni pubblicazione obbligatoria effettuata per questo procedimento. Usa il pulsante "Registra pubblicazione" per aggiungere un nuovo record, poi filtra per tipo o canale per consultare lo storico.',
  ppp_trasparenza_filtro_tipo: 'Tipo',
  ppp_trasparenza_filtro_canale: 'Canale',
  ppp_trasparenza_tab_checklist: 'Checklist Obblighi',
  ppp_trasparenza_registra_btn: 'Registra pubblicazione',
  ppp_trasparenza_registra_titolo: 'Registra pubblicazione obbligatoria',
  ppp_trasparenza_tipo_label: 'Tipo di pubblicazione',
  ppp_trasparenza_canale_label: 'Canale di pubblicazione',
  ppp_trasparenza_titolo_label: 'Titolo / Descrizione atto',
  ppp_trasparenza_data_label: 'Data pubblicazione',
  ppp_trasparenza_url_label: 'URL pubblicazione',
  ppp_trasparenza_riferimento_label: 'Riferimento normativo',
  ppp_trasparenza_note_label: 'Note',
  ppp_trasparenza_registrata: 'Pubblicazione registrata con successo.',
  ppp_trasparenza_eliminata: 'Pubblicazione eliminata.',
  ppp_trasparenza_nessuna: 'Nessuna pubblicazione registrata.',
  ppp_trasparenza_modalita_automatica: 'Automatica',
  ppp_trasparenza_modalita_manuale: 'Manuale',
  ppp_trasparenza_checklist_completa: 'Tutti gli obblighi di pubblicazione risultano assolti.',
  ppp_trasparenza_checklist_incompleta: 'Alcuni obblighi di pubblicazione non risultano ancora eseguiti.',
  ppp_trasparenza_filtra_fase: 'Filtra per fase',
  ppp_trasparenza_filtra_canale: 'Filtra per canale',
  ppp_trasparenza_filtra_tipo: 'Filtra per tipo',
  // Notifiche interne PPP
  ppp_notifiche_titolo: 'Notifiche PPP',
  ppp_notifiche_nessuna: 'Nessuna notifica.',
  ppp_notifiche_solo_non_lette: 'Solo non lette',
  ppp_notifiche_marca_tutte_lette: 'Segna tutte come lette',
  ppp_notifiche_tutte_lette: 'Tutte le notifiche sono state lette.',
  ppp_notifiche_non_lette: 'non letta',
  ppp_notifiche_aggiornate: 'Tutte le notifiche sono state segnate come lette.',
  // Reportistica PPP (task #86c9nq8hu)
  ppp_reportistica_titolo: 'Reportistica PPP',
  ppp_reportistica_sottotitolo: 'Report di compliance procedurale e performance ai sensi del D.lgs 36/2023 e L. 241/1990',
  ppp_reportistica_sidebar: 'Reportistica',
  ppp_report_genera: 'Genera report',
  ppp_report_caricamento: 'Caricamento...',
  ppp_report_seleziona_procedimento: 'Procedimento',
  ppp_report_scegli_procedimento: '— Scegli un procedimento —',
  ppp_report_scegli_rup: '— Scegli un RUP —',
  ppp_report_procedimento: 'Procedimento',
  ppp_report_stato: 'Stato',
  ppp_report_generato: 'Generato',
  ppp_report_fase: 'Fase',
  ppp_report_data_inizio: 'Data inizio',
  ppp_report_data_fine: 'Data fine',
  ppp_report_termine_legale: 'Termine legale',
  ppp_report_giorni_effettivi: 'Giorni eff.',
  ppp_report_scarto: 'Scarto',
  ppp_report_proroga: 'Proroga',
  ppp_report_motivazione_proroga: 'Motivazione proroga',
  ppp_report_periodo_inizio: 'Periodo dal',
  ppp_report_periodo_fine: 'Periodo al',
  ppp_report_tutti_gli_stati: 'Tutti gli stati',
  // Report avanzamento
  ppp_report_avanzamento_titolo: 'Report Avanzamento Procedimento',
  ppp_report_avanzamento_desc: 'Riepilogo per fase con stato, date e rispetto dei termini normativi.',
  // Report termini
  ppp_report_termini_titolo: 'Report Rispetto Termini Procedurali',
  ppp_report_termini_desc: 'Confronto tra scadenza normativa e data effettiva per ogni termine procedurale (art. 2 co. 9 L. 241/1990).',
  ppp_report_termini_totale: 'Totale scadenze',
  ppp_report_termini_rispettate: 'Rispettate',
  ppp_report_termini_in_ritardo: 'In ritardo',
  ppp_report_termini_prorogate: 'Prorogate',
  ppp_report_termini_col_scadenza: 'Scadenza',
  ppp_report_termini_col_normativa: 'Sc. normativa',
  ppp_report_termini_col_effettiva: 'Sc. effettiva',
  ppp_report_termini_col_rispettata: 'Data rispettata',
  // Report performance RUP
  ppp_report_performance_rup_titolo: 'Report Performance RUP',
  ppp_report_performance_rup_desc: 'Ritardi, proroghe motivate e procedimenti conclusi nei termini (art. 2, co. 9, L. 241/1990).',
  ppp_report_perf_assegnati: 'Procedimenti assegnati',
  ppp_report_perf_in_corso: 'In corso',
  ppp_report_perf_conclusi_ok: 'Conclusi nei termini',
  ppp_report_perf_ritardi: 'Scadenze in ritardo',
  ppp_report_perf_proroghe: 'Proroghe motivate',
  ppp_report_perf_sezione_ritardi: 'Scadenze in ritardo',
  ppp_report_perf_sezione_proroghe: 'Proroghe motivate',
  // Report pubblicazioni
  ppp_report_pubblicazioni_titolo: 'Report Pubblicazioni Obbligatorie',
  ppp_report_pubblicazioni_desc: 'Pubblicazioni effettuate per procedimento ai sensi dell\'art. 28, art. 35 D.lgs 36/2023 e D.lgs 33/2013.',
  ppp_report_pubb_totale: 'Totale pubblicazioni',
  ppp_report_pubb_obblighi_assolti: 'Obblighi assolti',
  ppp_report_pubb_obblighi_mancanti: 'Obblighi mancanti',
  ppp_report_pubb_tipo: 'Tipo pubblicazione',
  ppp_report_pubb_canale: 'Canale',
  ppp_report_pubb_titolo: 'Titolo',
  ppp_report_pubb_data: 'Data',
  ppp_report_pubb_registrato_da: 'Registrato da',
  ppp_report_pubb_url: 'URL',
  // Statistiche aggregate
  ppp_report_statistiche_titolo: 'Statistiche Aggregate',
  ppp_report_statistiche_desc: 'Volumi, tempi medi, distribuzione per fase e performance RUP su più procedimenti.',
  ppp_report_stats_totale: 'Totale procedimenti',
  ppp_report_stats_attivi: 'Attivi',
  ppp_report_stats_conclusi: 'Conclusi',
  ppp_report_stats_sospesi: 'Sospesi',
  ppp_report_stats_conformita: 'Conformità scadenze',
  ppp_report_stats_ritardi: 'Scadenze in ritardo',
  ppp_report_stats_prorogate: 'Prorogate',
  ppp_report_stats_per_fase: 'Distribuzione per fase',
  ppp_report_stats_per_rup: 'Performance per RUP',
  ppp_report_stats_n_proc: 'N° procedimenti',
  ppp_report_stats_media_giorni: 'Media giorni',
  ppp_report_stats_conformita_fase: 'Conformità',
};
